import type { GalleryCategory, GalleryItem } from '../types/content';
import { images } from './business';

export const galleryFilters: { id: GalleryCategory | 'all'; label: string }[] = [
  { id: 'all', label: 'All Projects' },
  { id: 'before-after', label: 'Before & After' },
  { id: 'resurfacing', label: 'Resurfacing' },
  { id: 'tile-coping', label: 'Tile & Coping' },
  { id: 'decks', label: 'Decks' },
  { id: 'completed', label: 'Completed Pools' },
];

export const galleryItems: GalleryItem[] = [
  {
    id: 'full-renovation',
    title: 'Full renovation',
    detail: 'New plaster, waterline tile, coping, and pavers',
    categories: ['before-after', 'resurfacing', 'tile-coping', 'decks'],
    image: images.after,
    imageAlt: 'Pool after renovation with new plaster, tile, and pavers',
    beforeImage: images.before,
    span: 'md:col-span-2 md:row-span-2',
  },
  {
    id: 'lanai-pool',
    title: 'Screened lanai pool',
    detail: 'Resurfacing with blue glass waterline tile',
    categories: ['completed', 'resurfacing', 'tile-coping'],
    image: images.hero,
    imageAlt: 'Finished kidney-shaped pool in a screened lanai',
    span: 'md:row-span-2',
  },
  {
    id: 'waterline',
    title: 'Waterline tile',
    detail: 'Glass mosaic tile under travertine coping',
    categories: ['tile-coping'],
    image: images.tile,
    imageAlt: 'Blue glass mosaic waterline tile',
    span: '',
  },
  {
    id: 'deck',
    title: 'Paver deck',
    detail: 'Travertine pavers around the pool',
    categories: ['decks', 'completed'],
    image: images.deck,
    imageAlt: 'Travertine paver pool deck',
    span: '',
  },
  {
    id: 'coping-ba',
    title: 'Tile & coping update',
    detail: 'Worn concrete edge replaced with stone and glass tile',
    categories: ['before-after', 'tile-coping'],
    image: images.tile,
    imageAlt: 'New glass tile and travertine coping',
    beforeImage: images.coping,
    span: 'md:col-span-2',
  },
  {
    id: 'pool-spa',
    title: 'Pool & spa',
    detail: 'New finish with a fresh gray paver deck',
    categories: ['completed', 'resurfacing', 'decks'],
    image: images.completed,
    imageAlt: 'Renovated pool and spa at golden hour',
    span: 'md:row-span-2',
  },
  {
    id: 'in-progress',
    title: 'Resurfacing in progress',
    detail: 'Fresh plaster being troweled smooth',
    categories: ['resurfacing'],
    image: images.plaster,
    imageAlt: 'Crew troweling fresh plaster in an empty pool',
    span: 'md:col-span-2',
  },
];
